// Personal information
export const personalInfo = {
  name: 'Muhammad Hussnain Ashiq',
  title: 'React Developer',
  tagline:
    'Building modern web applications with React. Passionate about creating beautiful, responsive, and user-friendly interfaces that make a difference.',
  description:
    "A passionate React developer creating beautiful, performant, and accessible web applications. Let's build something amazing together!",
  email: 'hussnainashiqforjob@gmail.com',
  phone: '+92 328 8086451',
  location: 'Raiwind, Lahore, Pakistan',
  github: 'HussnainAshiq-5657',
  linkedin: 'hussnainnaz-dev/',
  githubUrl: 'https://github.com/HussnainAshiq-5657',
  linkedinUrl: 'https://www.linkedin.com/in/hussnainnaz-dev/',
  emailUrl: 'mailto:hussnainashiqforjob@gmail.com',
  phoneUrl: 'tel:+923288086451',
  locationUrl: 'https://maps.google.com/?q=Raiwind,+Lahore,+Pakistan',
  cvUrl: process.env.PUBLIC_URL + '/cv/Muhammad Hussnain Ashiq Resume.pdf',
};

// About section content
export const aboutContent = {
  title: 'My Journey as a React Developer',
  paragraphs: [
    "I'm a passionate React developer with a love for creating beautiful, performant web applications. My journey began with curiosity about how websites work, and it has evolved into a deep passion for front-end development and user experience.",
    "I'm building my expertise in React development using modern tools and best practices. I'm committed to writing clean, maintainable code and creating accessible, responsive user interfaces that work seamlessly across all devices.",
    "When I'm not coding, you can find me exploring new technologies, working on personal projects, or learning from the developer community. I believe in continuous learning and staying up-to-date with the latest trends in web development.",
  ],
};

// Skills with proficiency levels
export const aboutSkills = [
  { name: 'React', level: 75 },
  { name: 'JavaScript', level: 75 },
  { name: 'HTML', level: 90 },
  { name: 'CSS', level: 90 },
  { name: 'TailwindCSS', level: 75 },
  { name: 'Git', level: 70 },
];
